import { useEffect, useState } from 'react'
import { AlertCircle, Eye, Clock } from 'lucide-react'

/**
 * Version banner that displays at the top of preview/last sites
 * to indicate which version the user is viewing
 */
const VersionBanner = () => {
  const [version, setVersion] = useState<string | null>(null)

  useEffect(() => {
    // @ts-ignore - __TENANT_CONFIG__ is injected at build time
    if (typeof __TENANT_CONFIG__ !== 'undefined' && __TENANT_CONFIG__.version) {
      const siteVersion = __TENANT_CONFIG__.version

      // Only show banner for preview and last versions (not live)
      if (siteVersion === 'preview' || siteVersion === 'last') {
        setVersion(siteVersion)
      }
    }
  }, [])

  // Don't render anything for live sites or if no version detected
  if (!version) return null

  const isPreview = version === 'preview'
  const isLast = version === 'last'

  return (
    <>
      {/* Fixed banner at top */}
      <div
        className={`fixed top-0 left-0 right-0 z-50 ${
          isPreview ? 'bg-blue-600' : 'bg-orange-600'
        } text-white shadow-lg`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2">
          <div className="flex items-center justify-center gap-3">
            {isPreview && (
              <>
                <Eye className="h-5 w-5" />
                <span className="font-semibold text-sm sm:text-base">
                  PREVIEW VERSION
                </span>
                <span className="hidden sm:inline text-sm opacity-90">
                  — This is a preview of unpublished changes
                </span>
              </>
            )}
            {isLast && (
              <>
                <Clock className="h-5 w-5" />
                <span className="font-semibold text-sm sm:text-base">
                  ROLLBACK VERSION
                </span>
                <span className="hidden sm:inline text-sm opacity-90">
                  — This is the last published version (backup)
                </span>
              </>
            )}
            <AlertCircle className="h-4 w-4 ml-2 opacity-75" />
          </div>
        </div>
      </div>
      {/* Spacer to push content below fixed banner */}
      <div className="h-11"></div>
    </>
  )
}

export default VersionBanner
